import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    StockCardCategoryComponent,
    UpdateStockCardCategoryMutationVariables,
    useRemoveStockCardCategoryMutation,
    useUpdateStockCardCategoryMutation,
} from '../../../../generated/graphql';
import { routePaths } from '../../../../routePaths';
import { FullScreenDialog, RemovalConfirmationDialog } from '../../../../ui-kit';
import { STOCK_CARD_CATEGORIES } from '../../graphql/queries';
import StockCardCategoryForm, { StockCardCategoryFormValues } from './WarehouseCategoryForm';
import RemoveWarehouseCategoryTitle from './RemoveWarehouseCategoryTitle';

const UpdateWarehouseCategoryForm = () => {
    const [isDialogOpened, setIsDialogOpened] = useState(true);
    const [isRemovalConfirmtionDialogOpen, setIsRemovalConfirmtionDialogOpen] = useState(false);
    const openRemovalConfirmationDialog = () => setIsRemovalConfirmtionDialogOpen(true);
    const closeRemovalConfirmationDialog = () => setIsRemovalConfirmtionDialogOpen(false);

    const theme = useTheme();
    const history = useHistory();
    const { params: { id: stockCardCategoryId } } = useRouteMatch();

    const [updateWarehouseCategory] = useUpdateStockCardCategoryMutation({ refetchQueries: [{ query: STOCK_CARD_CATEGORIES }] });
    const [removeWarehouseCategory] = useRemoveStockCardCategoryMutation({
        variables: { id: stockCardCategoryId },
        refetchQueries: [{ query: STOCK_CARD_CATEGORIES }],
    });

    const onClose = () => {
        setIsDialogOpened(false);
        setTimeout(() => history.push(routePaths.warehouseCategories), theme.transitions.duration.leavingScreen);
    };


    const onSubmit = async ({ name }: StockCardCategoryFormValues) => {
        const variables: UpdateStockCardCategoryMutationVariables = {
            id: stockCardCategoryId,
            data: {
                name,
            },
        };
        await updateWarehouseCategory({ variables });
        onClose();
    };

    const onRemove = async () => {
        try {
            await removeWarehouseCategory();
            onClose();
        } catch (error) {
            console.error(error);
        }
    };

    const { t } = useTranslation();

    return (
        <FullScreenDialog isOpened={isDialogOpened}>
            <StockCardCategoryComponent variables={{ id: stockCardCategoryId }}>
                {({ data: { stockCardCategory } }) => (
                    <>
                        <StockCardCategoryForm
                            buttonText={t('Update')}
                            dialogName={t('Update warehouse category')}
                            initialValues={{
                                name: stockCardCategory.name,
                            }}
                            onClose={onClose}
                            onRemove={openRemovalConfirmationDialog}
                            onSubmit={onSubmit}
                        />
                        <RemovalConfirmationDialog
                            dialogTitle={<RemoveWarehouseCategoryTitle warehouseCategoryName={stockCardCategory.name} />}
                            dialogContent={t(
                                'Are you sure you want to remove {{name}}?',
                                { name: stockCardCategory.name }
                            )}
                            isOpen={isRemovalConfirmtionDialogOpen}
                            handleClose={closeRemovalConfirmationDialog}
                            handleRemove={onRemove}
                        />
                    </>
                )}
            </StockCardCategoryComponent>
        </FullScreenDialog>
    );
};

export default UpdateWarehouseCategoryForm;
